import React from "react"
import "./product-details.css"

export default function ProductVariantSelector({ variants, selectedVariant, onSelectVariant }) {
  return (
    <div className="product_details_variant_container">
      <h3 className="product_details_variant_title">Flavor</h3>
      <div className="product_details_variant_options">
        {variants.map((variant, index) => (
          <span
            key={variant}
            // className={`product_details_variant_btn ${
            //   selectedVariant === index ? "product_details_variant_selected" : ""
            // }`}
            style={{
              fontSize: "20px",
            }}
            onClick={() => onSelectVariant(index)}
          >
            {variant}
            {index < variants.length - 1 && ", "}  {/* Add comma except for the last item */}
          </span>
        ))}
      </div>
    </div>
  )
}
